// extracted by mini-css-extract-plugin
export default {"chip":"LanguageCard_chip__0WK7A","label":"LanguageCard_label__Rwok-","remove":"LanguageCard_remove__P0NFD"};